/* SORAS Héritage — Analiza părului (front-end) */
(function () {
  'use strict';

  var STEPS = [
    { id: 'who', type: 'single', q: 'Pentru cine este analiza?', opts: [
      ['female', 'Pentru mine — femeie'],
      ['male', 'Pentru mine — bărbat'],
      ['na', 'Prefer să nu spun']
    ]},
    { id: 'concerns', type: 'multi', max: 3, q: 'Ce te preocupă cel mai mult?', hint: 'Alege până la 3 variante.', opts: [
      ['hair_loss', 'Căderea părului'],
      ['slow_growth', 'Părul crește greu'],
      ['thin', 'Păr subțire, fără volum'],
      ['damage', 'Vârfuri rupte, păr deteriorat'],
      ['oily', 'Scalp gras'],
      ['dry_itchy', 'Scalp uscat sau cu mâncărimi'],
      ['dull', 'Păr fără strălucire']
    ]},
    { id: 'scalp', type: 'single', q: 'Cum arată scalpul tău la 1–2 zile după spălare?', opts: [
      ['oily', 'Gras', 'Părul se lipește la rădăcină'],
      ['normal', 'Normal', 'Echilibrat, fără disconfort'],
      ['dry', 'Uscat', 'Tensionat, uneori cu mătreață fină'],
      ['mixed', 'Mixt', 'Gras la rădăcină, uscat pe lungimi']
    ]},
    { id: 'duration', type: 'single', q: 'De cât timp observi problema?', opts: [
      ['lt3', 'Sub 3 luni'],
      ['3to12', 'Între 3 și 12 luni'],
      ['gt12', 'De peste un an'],
      ['prevent', 'Nu am o problemă, vreau prevenție']
    ]},
    { id: 'treatments', type: 'multi', max: 5, exclusive: 'none', q: 'Ce faci de obicei cu părul?', hint: 'Poți alege mai multe variante.', opts: [
      ['dyed', 'Îl vopsesc'],
      ['bleached', 'Decolorare sau șuvițe'],
      ['heat', 'Placă sau ondulator des'],
      ['tight', 'Coafuri strânse (coc, coadă)'],
      ['none', 'Nimic din acestea']
    ]},
    { id: 'wash', type: 'single', q: 'Cât de des îți speli părul?', opts: [
      ['daily', 'Zilnic'],
      ['2-3', 'La 2–3 zile'],
      ['weekly', 'O dată pe săptămână sau mai rar']
    ]},
    { id: 'photos', type: 'photos' }
  ];

  var METRIC_LABELS = {
    scalp: 'Sănătatea scalpului',
    density: 'Densitate',
    strength: 'Rezistența firului',
    hydration: 'Hidratare și strălucire'
  };

  var LOADING_MSGS = [
    'Analizăm scalpul…',
    'Evaluăm densitatea părului…',
    'Verificăm lungimile și vârfurile…',
    'Alegem produsele potrivite…',
    'Construim ritualul tău SORAS…'
  ];

  var ICON = {
    upload: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 16.5V18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1.5"/><path d="M7.5 9 12 4.5 16.5 9"/><path d="M12 4.5V16"/></svg>',
    back: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>',
    warn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><circle cx="12" cy="16.5" r=".6" fill="currentColor"/></svg>',
    camera: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>',
    flip: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5.3L20 9"/><path d="M20 4v5h-5"/><path d="M20 12a8 8 0 0 1-14 5.3L4 15"/><path d="M4 20v-5h5"/></svg>',
    gallery: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 16l-5-5-9 9"/></svg>',
    selfie: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><ellipse cx="24" cy="26" rx="11" ry="14"/><path d="M13 22c2-8 7-11 11-11s9 3 11 11"/><path d="M15 17c3-1 6-4 9-6 3 2 6 5 9 6"/><path d="M6 10V6h4M42 10V6h-4M6 38v4h4M42 38v4h-4"/></svg>',
    crown: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="24" cy="24" r="14"/><path d="M24 10v28"/><path d="M18 12c2 4 3 8 3 12M30 12c-2 4-3 8-3 12M13 18c3 2 5 4 6 7M35 18c-3 2-5 4-6 7"/><path d="M6 10V6h4M42 10V6h-4M6 38v4h4M42 38v4h-4"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 7h3l2-3h6l2 3h3v12H4z"/><circle cx="12" cy="13" r="3.5"/></svg>'
  };

  var DEMO_REPORT = {
    photo_quality: 'good', photo_note: '',
    hair_score: 64,
    headline: 'Scalp gras, rădăcini care cer echilibru',
    summary: 'Scalpul pare încărcat la rădăcină, iar cărarea se vede puțin mai lată în zona creștetului. Lungimile arată în general bine, cu ușoare semne de uscăciune la vârfuri. Prioritatea este echilibrarea scalpului și stimularea rădăcinilor.',
    metrics: [
      { key: 'scalp', score: 52, note: 'Aspect gras la rădăcină și ușoare depuneri de produs.' },
      { key: 'density', score: 61, note: 'Cărarea pare ușor mai lată în zona creștetului.' },
      { key: 'strength', score: 74, note: 'Firul arată rezistent, fără rupturi vizibile pe lungimi.' },
      { key: 'hydration', score: 68, note: 'Vârfurile par puțin uscate, lungimile au strălucire medie.' }
    ],
    observations: [
      'Rădăcini cu aspect gras la 1–2 zile după spălare',
      'Cărare ușor lărgită în zona creștetului',
      'Vârfuri ușor uscate, fără despicări evidente'
    ],
    priority: 'scalp',
    products: [
      { key: 'serum', why: 'Echilibrează sebumul, reduce depunerile și susține rădăcinile, fără să îngreuneze părul.', how: 'Câteva picături seara pe cărare, cu masaj 2 minute. Fără clătire.' },
      { key: 'rosemary', why: 'Hrănește scalpul și susține creșterea, ca tratament scurt înainte de spălare.', how: 'De 2 ori pe săptămână, pe scalp, cu 1 oră înainte de spălare.' },
      { key: 'brush', why: 'Ajută la îndepărtarea depunerilor de produs și stimulează circulația la nivelul scalpului.', how: 'La fiecare spălare, cu șampon, 1–2 minute în mișcări circulare ușoare.' }
    ],
    routine: [
      { when: 'Zilnic, seara', action: 'Câteva picături de ser pe cărare, apoi masaj ușor 2 minute. Nu clăti.' },
      { when: 'De 2 ori pe săptămână', action: 'Ulei de rozmarin pe scalp cu 1 oră înainte de spălare.' },
      { when: 'La fiecare spălare', action: 'Masează scalpul cu peria SORAS în timpul șamponării.' },
      { when: 'Obicei util', action: 'Evită să atingi des rădăcinile și spală periuța și fața de pernă săptămânal.' }
    ],
    expectation: 'Primele schimbări de aspect apar, de obicei, după 6–8 săptămâni de folosire constantă.',
    lashes: { visible: true, sparse: true, note: 'Genele tale pot arăta mai pline: uleiul de ricin, aplicat seara, le hrănește de la rădăcină.' },
    see_doctor: false, doctor_note: ''
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    var f = format || '{{amount_with_comma_separator}} lei';
    var n = (cents || 0) / 100;
    function fmt(num, dec, th, de) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(de);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(n, 0, '.', ',');
      return fmt(n, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', name, data || {}); } catch (e) {}
  }

  function prepareImage(file) {
    var MAX = 1280;
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type || 'image/')) return reject(new Error('type'));
      var draw = function (src, w, h) {
        var scale = Math.min(1, MAX / Math.max(w, h));
        var cw = Math.round(w * scale), ch = Math.round(h * scale);
        var c = document.createElement('canvas');
        c.width = cw; c.height = ch;
        c.getContext('2d').drawImage(src, 0, 0, cw, ch);
        var url = c.toDataURL('image/jpeg', 0.85);
        resolve({ preview: url, data: url.split(',')[1], media_type: 'image/jpeg' });
      };
      if (window.createImageBitmap) {
        createImageBitmap(file, { imageOrientation: 'from-image' })
          .then(function (bmp) { draw(bmp, bmp.width, bmp.height); })
          .catch(fallback);
      } else fallback();
      function fallback() {
        var img = new Image();
        img.onload = function () { draw(img, img.naturalWidth, img.naturalHeight); URL.revokeObjectURL(img.src); };
        img.onerror = function () { reject(new Error('decode')); };
        img.src = URL.createObjectURL(file);
      }
    });
  }

  function toast(msg, link) {
    var t = document.querySelector('.sha-toast');
    if (!t) { t = document.createElement('div'); t.className = 'sha-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (link ? '<a href="' + esc(link.href) + '">' + esc(link.label) + '</a>' : '');
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 5000);
  }

  function init(root) {
    var cfgEl = root.querySelector('script[data-ha-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    cfg.products = cfg.products || {};
    var stage = root.querySelector('[data-ha-stage]');
    var routesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var state = { step: -1, answers: { concerns: [], treatments: [] }, photos: [null, null], consent: false, report: null, busy: false };

    function scrollTop() {
      var r = root.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: window.scrollY + r.top - 80, behavior: 'smooth' });
    }

    function render(html, opts) {
      if (!opts || !opts.keepCam) stopCamera();
      stage.innerHTML = '<div class="sha-card sha-fade">' + html + '</div>';
      if (!opts || opts.scroll !== false) scrollTop();
      var h = stage.querySelector('h2,h3');
      if (h && opts && opts.focus) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    }

    /* ---------- Intro ---------- */
    function renderIntro() {
      state.step = -1;
      render(
        '<div class="sha-intro">' +
          '<div>' +
            '<div class="sha-kicker">Analiză personalizată · gratuită</div>' +
            '<h2>' + (cfg.heading ? esc(cfg.heading) : 'Află scorul de sănătate <em>al părului tău</em>') + '</h2>' +
            '<p class="sha-intro-lead">' + esc(cfg.subheading || 'Răspunzi la 6 întrebări, încarci o fotografie a scalpului și primești în 2 minute o analiză a părului și ritualul SORAS potrivit pentru tine.') + '</p>' +
            '<div class="sha-pills"><span class="sha-pill">Scor pe 4 zone</span><span class="sha-pill">Ritual pas cu pas</span><span class="sha-pill">Fotografia nu e salvată</span></div>' +
            '<button type="button" class="sha-btn sha-btn--accent" data-ha-start>Începe analiza</button>' +
            '<p class="sha-intro-foot">Durează aproximativ 2 minute.</p>' +
          '</div>' +
          '<div class="sha-intro-visual" aria-hidden="true">' + introVisual() + '</div>' +
        '</div>', { scroll: false });
      stage.querySelector('[data-ha-start]').addEventListener('click', function () { track('hair_analysis_start'); go(0); });
    }

    function introVisual() {
      var r = 112, c = 2 * Math.PI * r;
      return '<svg viewBox="0 0 300 300">' +
        '<circle cx="150" cy="150" r="140" fill="#F4EADD"/>' +
        '<circle cx="150" cy="150" r="' + r + '" fill="none" stroke="#E8E0D3" stroke-width="10"/>' +
        '<circle cx="150" cy="150" r="' + r + '" fill="none" stroke="#8B5A2B" stroke-width="10" stroke-linecap="round" stroke-dasharray="' + c + '" stroke-dashoffset="' + (c * 0.22) + '" transform="rotate(-90 150 150)"/>' +
        '<g fill="none" stroke="#1D1A16" stroke-width="1.4" stroke-linecap="round" opacity=".85">' +
          '<path d="M128 214c-6-30-2-62 10-92s16-46 12-62"/><path d="M144 216c-3-28 2-58 12-86s12-46 6-64"/>' +
          '<path d="M160 216c2-26 8-52 16-78s8-44 0-60"/><path d="M174 212c4-22 12-44 18-66s2-40-8-54"/>' +
          '<path d="M114 208c-8-24-8-50 0-76s14-48 12-62"/>' +
        '</g>' +
        '<text x="150" y="243" text-anchor="middle" font-family="Cormorant Garamond, serif" font-size="20" fill="#8B5A2B" font-style="italic">scor 78 / 100</text>' +
      '</svg>';
    }

    /* ---------- Quiz ---------- */
    function go(i) {
      state.step = i;
      var s = STEPS[i];
      if (s.type === 'photos') renderPhotos(); else renderQuestion(s);
    }

    function header(i) {
      var total = STEPS.length;
      return '<div class="sha-top"><button type="button" class="sha-back" data-ha-back>' + ICON.back + 'Înapoi</button><span>Pasul ' + (i + 1) + ' din ' + total + '</span></div>' +
        '<div class="sha-progress" role="progressbar" aria-valuemin="1" aria-valuemax="' + total + '" aria-valuenow="' + (i + 1) + '"><span style="width:' + Math.round(((i + 1) / total) * 100) + '%"></span></div>';
    }

    function bindBack() {
      var b = stage.querySelector('[data-ha-back]');
      if (b) b.addEventListener('click', function () { state.step > 0 ? go(state.step - 1) : renderIntro(); });
    }

    function renderQuestion(s) {
      var multi = s.type === 'multi';
      var cur = state.answers[s.id];
      var html = header(state.step) +
        '<h2 class="sha-q" id="sha-q-' + s.id + '">' + esc(s.q) + '</h2>' +
        (s.hint ? '<p class="sha-hint">' + esc(s.hint) + '</p>' : '') +
        '<div class="sha-opts" role="group" aria-labelledby="sha-q-' + s.id + '">' +
        s.opts.map(function (o) {
          var on = multi ? (cur || []).indexOf(o[0]) > -1 : cur === o[0];
          return '<button type="button" class="sha-opt' + (multi ? ' sha-opt--multi' : '') + '" data-v="' + o[0] + '" aria-pressed="' + on + '">' +
            '<span class="sha-opt-mark"></span><span>' + esc(o[1]) + (o[2] ? '<span class="sha-opt-sub">' + esc(o[2]) + '</span>' : '') + '</span></button>';
        }).join('') +
        '</div>' +
        (multi ? '<div class="sha-actions"><button type="button" class="sha-btn sha-btn--block" data-ha-next' + ((cur || []).length ? '' : ' disabled') + '>Continuă</button></div>' : '');
      render(html, { focus: true });
      bindBack();

      stage.querySelectorAll('.sha-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-v');
          if (!multi) {
            state.answers[s.id] = v;
            stage.querySelectorAll('.sha-opt').forEach(function (b) { b.setAttribute('aria-pressed', b === btn); });
            setTimeout(function () { go(state.step + 1); }, 220);
            return;
          }
          var arr = state.answers[s.id] = (state.answers[s.id] || []).slice();
          var idx = arr.indexOf(v);
          if (idx > -1) arr.splice(idx, 1);
          else {
            if (s.exclusive && v === s.exclusive) arr.length = 0;
            else if (s.exclusive) { var ex = arr.indexOf(s.exclusive); if (ex > -1) arr.splice(ex, 1); }
            if (arr.length >= s.max) arr.shift();
            arr.push(v);
          }
          stage.querySelectorAll('.sha-opt').forEach(function (b) { b.setAttribute('aria-pressed', arr.indexOf(b.getAttribute('data-v')) > -1); });
          stage.querySelector('[data-ha-next]').disabled = arr.length === 0;
        });
      });
      var next = stage.querySelector('[data-ha-next]');
      if (next) next.addEventListener('click', function () { go(state.step + 1); });
    }

    /* ---------- Photos ---------- */
    function slot(i, title, tag, tip) {
      var p = state.photos[i];
      return '<div class="sha-slot' + (p ? ' sha-slot--filled' : '') + '">' +
        '<span class="sha-slot-title">' + esc(title) + '<span class="sha-slot-tag">' + esc(tag) + '</span></span>' +
        (p ? '<img class="sha-slot-img" src="' + p.preview + '" alt="">'
           : '<span class="sha-slot-drop">' + (i === 0 ? ICON.selfie : ICON.crown) + '</span><span class="sha-slot-tip">' + esc(tip) + '</span>') +
        '<div class="sha-slot-actions">' +
          (i === 0
            ? '<button type="button" class="sha-btn sha-btn--sm' + (p ? ' sha-btn--ghost' : '') + '" data-cam="' + i + '">' + ICON.camera + (p ? 'Refă poza' : 'Fă poza cu ghidaj') + '</button>' +
              '<label class="sha-upload">sau încarcă din galerie<input class="sha-sr" type="file" accept="image/*" data-slot="' + i + '"></label>'
            : '<label class="sha-btn sha-btn--sm' + (p ? ' sha-btn--ghost' : '') + '">' + ICON.gallery + (p ? 'Schimbă fotografia' : 'Încarcă o fotografie') + '<input class="sha-sr" type="file" accept="image/*" data-slot="' + i + '"></label>') +
        '</div>' +
      '</div>';
    }

    function renderPhotos(errMsg) {
      var privacy = cfg.privacyUrl || '/pages/politica-de-confidentialitate';
      var html = header(state.step) +
        '<h2 class="sha-q">Acum, fotografiile</h2>' +
        '<p class="sha-hint">Camera te ghidează: verificăm poziția, privirea și lumina, apoi poza se face singură.</p>' +
        '<div class="sha-slots">' +
          slot(0, 'Linia părului', 'obligatoriu', 'Un selfie din față, cu tot părul de sus în cadru.') +
          slot(1, 'Creștetul sau cărarea', 'recomandat', 'Alege din galerie o poză făcută de sus, cu creștetul sau cărarea la vedere.') +
        '</div>' +
        '<ul class="sha-tips"><li>Stai cu fața spre o fereastră, la lumină naturală.</li><li>Fără filtre, fără șapcă sau bentiță.</li><li>Păr uscat și pieptănat, fără produse de styling.</li></ul>' +
        '<label class="sha-consent"><input type="checkbox" data-ha-consent' + (state.consent ? ' checked' : '') + '><span>Sunt de acord ca fotografiile mele să fie procesate automat pentru această analiză. Fotografiile nu sunt salvate după analiză. <a href="' + esc(privacy) + '" target="_blank" rel="noopener">Politica de confidențialitate</a></span></label>' +
        (errMsg ? '<div class="sha-err" role="alert">' + esc(errMsg) + '</div>' : '') +
        '<div class="sha-actions"><button type="button" class="sha-btn sha-btn--accent sha-btn--block" data-ha-go>Analizează părul meu</button></div>';
      render(html, { focus: !errMsg });
      bindBack();

      var goBtn = stage.querySelector('[data-ha-go]');
      function sync() { goBtn.disabled = !(state.photos[0] && state.consent) || state.busy; }
      sync();

      stage.querySelector('[data-ha-consent]').addEventListener('change', function (e) { state.consent = e.target.checked; sync(); });
      stage.querySelectorAll('input[type=file]').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var f = inp.files && inp.files[0];
          if (!f) return;
          var i = +inp.getAttribute('data-slot');
          state.busy = true; sync();
          prepareImage(f).then(function (img) {
            state.photos[i] = img; state.busy = false; renderPhotos();
          }).catch(function () {
            state.busy = false;
            renderPhotos('Nu am putut citi fotografia. Încearcă o imagine JPG sau PNG.');
          });
        });
      });
      stage.querySelectorAll('[data-cam]').forEach(function (b) {
        b.addEventListener('click', function () { openCamera(+b.getAttribute('data-cam')); });
      });
      goBtn.addEventListener('click', submit);
    }

    /* ---------- Camera cu ghidaj ---------- */
    var MP_BASE = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
    var MP_MODEL = 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite';
    var detectorP = null;
    var cam = null;

    // Shopify minifică JS-ul temei și strică importul dinamic, așa că încărcăm modulul printr-un script de tip module
    function importVision() {
      return new Promise(function (resolve, reject) {
        if (window.__shaVision) return resolve(window.__shaVision);
        var ev = 'sha-vision-' + Date.now();
        var s = document.createElement('script');
        s.type = 'module';
        s.textContent = 'import * as v from "' + MP_BASE + '/vision_bundle.mjs"; window.__shaVision = v; window.dispatchEvent(new Event("' + ev + '"));';
        window.addEventListener(ev, function () { resolve(window.__shaVision); }, { once: true });
        setTimeout(function () { if (!window.__shaVision) reject(new Error('timeout')); }, 15000);
        document.head.appendChild(s);
      });
    }

    function loadDetector() {
      if (detectorP) return detectorP;
      detectorP = importVision().then(function (v) {
        return v.FilesetResolver.forVisionTasks(MP_BASE + '/wasm').then(function (files) {
          var opts = function (d) {
            return { baseOptions: { modelAssetPath: MP_MODEL, delegate: d }, runningMode: 'VIDEO', minDetectionConfidence: 0.5 };
          };
          return v.FaceDetector.createFromOptions(files, opts('GPU')).catch(function () {
            return v.FaceDetector.createFromOptions(files, opts('CPU'));
          });
        });
      });
      detectorP.catch(function () { detectorP = null; });
      return detectorP;
    }

    function stopCamera() {
      if (!cam) return;
      cam.active = false;
      cancelAnimationFrame(cam.raf);
      clearInterval(cam.timer);
      if (cam.stream) cam.stream.getTracks().forEach(function (t) { t.stop(); });
      if (cam.audio && cam.audio.close) { try { cam.audio.close(); } catch (e) {} }
      cam = null;
    }

    function beep(freq, len) {
      try {
        if (!cam || !cam.audio) return;
        var a = cam.audio, o = a.createOscillator(), g = a.createGain();
        o.frequency.value = freq; g.gain.value = 0.06;
        o.connect(g); g.connect(a.destination);
        o.start(); o.stop(a.currentTime + (len || 0.08));
      } catch (e) {}
    }

    var CAM_MODES = {
      face: {
        title: 'Selfie: linia părului',
        facing: 'user',
        mask: '<path fill="rgba(0,0,0,.38)" fill-rule="evenodd" d="M0 0H300V400H0Z M150 55A108 150 0 1 1 149.99 55Z"/><ellipse data-cam-guide cx="150" cy="205" rx="108" ry="150" fill="none" stroke="#fff" stroke-width="2"/>',
        chips: [['pos', 'Poziția capului'], ['look', 'Privește drept'], ['light', 'Lumină']],
        start: 'Ține fața în oval, cu tot părul de sus în cadru.'
      },
      top: {
        title: 'Creștetul sau cărarea',
        facing: 'environment',
        mask: '<path fill="rgba(0,0,0,.38)" fill-rule="evenodd" d="M0 0H300V400H0Z M150 80A120 120 0 1 1 149.99 80Z"/><circle data-cam-guide cx="150" cy="200" r="120" fill="none" stroke="#fff" stroke-width="2"/>',
        chips: [['light', 'Lumină'], ['still', 'Ține nemișcat'], ['sharp', 'Claritate']],
        start: 'Încadrează creștetul sau cărarea în cerc, de la 20–30 cm.'
      }
    };

    function openCamera(slotIdx, facingOverride) {
      var mode = slotIdx === 0 ? 'face' : 'top';
      var M = CAM_MODES[mode];
      var facing = facingOverride || M.facing;
      var html =
        '<div class="sha-top"><button type="button" class="sha-back" data-cam-cancel>' + ICON.back + 'Înapoi</button><span>' + esc(M.title) + '</span></div>' +
        '<div class="sha-cam' + (facing === 'user' ? ' sha-cam--mirror' : '') + '" data-cam-box>' +
          '<video playsinline muted autoplay></video>' +
          '<svg class="sha-cam-mask" viewBox="0 0 300 400" preserveAspectRatio="none" aria-hidden="true">' + M.mask + '</svg>' +
          '<div class="sha-cam-chips">' + M.chips.map(function (c) {
            return '<div class="sha-chip" data-chip="' + c[0] + '" data-s="wait"><span>' + esc(c[1]) + '</span><b>…</b></div>';
          }).join('') + '</div>' +
          '<div class="sha-cam-count" data-cam-count aria-live="assertive"></div>' +
          '<p class="sha-cam-tip" data-cam-tip>Pornim camera…</p>' +
          '<div class="sha-cam-flash" data-cam-flash></div>' +
        '</div>' +
        '<div class="sha-cam-actions">' +
          '<button type="button" class="sha-btn sha-btn--sm sha-btn--ghost" data-cam-flip>' + ICON.flip + 'Schimbă camera</button>' +
          '<button type="button" class="sha-shutter" data-cam-shoot aria-label="Fă poza acum"></button>' +
          '<label class="sha-upload">Încarcă din galerie<input class="sha-sr" type="file" accept="image/*" data-cam-file></label>' +
        '</div>' +
        '<p class="sha-cam-note">Poza se face automat când toate verificările sunt verzi. Imaginea rămâne pe telefonul tău până apeși „Analizează”.</p>';
      render(html, { focus: true, keepCam: false });

      var box = stage.querySelector('[data-cam-box]');
      var video = box.querySelector('video');
      var tipEl = stage.querySelector('[data-cam-tip]');
      var countEl = stage.querySelector('[data-cam-count]');
      var guide = box.querySelector('[data-cam-guide]');
      var AC = window.AudioContext || window.webkitAudioContext;

      cam = {
        active: true, slot: slotIdx, mode: mode, facing: facing, video: video,
        raf: 0, timer: 0, last: 0, goodSince: 0, count: 0, prev: null, detector: null, detectorFailed: false,
        audio: AC ? new AC() : null
      };
      var me = cam;

      stage.querySelector('[data-cam-cancel]').addEventListener('click', function () { renderPhotos(); });
      stage.querySelector('[data-cam-flip]').addEventListener('click', function () {
        openCamera(slotIdx, facing === 'user' ? 'environment' : 'user');
      });
      stage.querySelector('[data-cam-shoot]').addEventListener('click', function () { capture(); });
      stage.querySelector('[data-cam-file]').addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0];
        if (!f) return;
        prepareImage(f).then(function (img) { state.photos[slotIdx] = img; renderPhotos(); })
          .catch(function () { renderPhotos('Nu am putut citi fotografia. Încearcă o imagine JPG sau PNG.'); });
      });

      function fail(msg) {
        if (cam !== me) return;
        stopCamera();
        box.classList.add('sha-cam--off');
        tipEl.textContent = msg;
        box.querySelector('.sha-cam-chips').style.display = 'none';
        stage.querySelector('[data-cam-shoot]').disabled = true;
      }

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        fail('Browserul nu permite accesul la cameră. Încarcă o fotografie din galerie.');
        return;
      }

      navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: facing }, width: { ideal: 1280 }, height: { ideal: 1280 } },
        audio: false
      }).then(function (stream) {
        if (cam !== me) { stream.getTracks().forEach(function (t) { t.stop(); }); return; }
        me.stream = stream;
        video.srcObject = stream;
        var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
        tipEl.textContent = M.start;
        if (mode === 'face') {
          var slow = setTimeout(function () { if (!me.detector) me.detectorFailed = true; }, 9000);
          loadDetector().then(function (d) { clearTimeout(slow); me.detector = d; me.detectorFailed = false; })
            .catch(function () { clearTimeout(slow); me.detectorFailed = true; });
        }
        me.raf = requestAnimationFrame(tick);
      }).catch(function (err) {
        var denied = err && (err.name === 'NotAllowedError' || err.name === 'SecurityError');
        fail(denied
          ? 'Nu avem acces la cameră. Permite accesul din setările browserului sau încarcă o fotografie din galerie.'
          : 'Camera nu a putut porni. Încarcă o fotografie din galerie.');
      });

      // canvas mic pentru măsurători
      var SW = 96, SH = 128;
      var sc = document.createElement('canvas'); sc.width = SW; sc.height = SH;
      var sx = sc.getContext('2d', { willReadFrequently: true });

      function setChip(key, s, label) {
        var el = box.querySelector('[data-chip="' + key + '"]');
        if (!el) return;
        el.setAttribute('data-s', s);
        el.querySelector('b').textContent = label || (s === 'good' ? 'Bun' : s === 'bad' ? 'Ajustează' : '…');
      }

      // dreptunghiul afișat (object-fit: cover) în coordonate video
      function toView(x, y) {
        var vw = video.videoWidth, vh = video.videoHeight, W = box.clientWidth, H = box.clientHeight;
        var k = Math.max(W / vw, H / vh);
        return { x: (x * k - (vw * k - W) / 2) / W, y: (y * k - (vh * k - H) / 2) / H };
      }

      function frameStats() {
        sx.drawImage(video, 0, 0, SW, SH);
        var d = sx.getImageData(0, 0, SW, SH).data;
        var n = SW * SH, g = new Float32Array(n), sum = 0, motion = 0;
        for (var i = 0, p = 0; i < n; i++, p += 4) { g[i] = d[p] * 0.299 + d[p + 1] * 0.587 + d[p + 2] * 0.114; sum += g[i]; }
        if (me.prev) { for (var j = 0; j < n; j++) motion += Math.abs(g[j] - me.prev[j]); motion /= n; } else motion = 99;
        me.prev = g;
        var lap = 0, lm = 0, cnt = 0;
        if (mode === 'top') {
          for (var y = 1; y < SH - 1; y++) for (var x = 1; x < SW - 1; x++) {
            var q = y * SW + x;
            var v = 4 * g[q] - g[q - 1] - g[q + 1] - g[q - SW] - g[q + SW];
            lap += v * v; lm += v; cnt++;
          }
          lap = lap / cnt - (lm / cnt) * (lm / cnt);
        }
        return { light: sum / n, motion: motion, sharp: lap };
      }

      function tick(now) {
        if (!me.active) return;
        me.raf = requestAnimationFrame(tick);
        if (now - me.last < 110 || video.readyState < 2 || !video.videoWidth) return;
        me.last = now;

        var st = frameStats(), tip = '', ok = true;
        var bad = function (key, msg) { setChip(key, 'bad'); ok = false; if (!tip) tip = msg; };

        // Lumină
        if (st.light < 55) bad('light', 'E prea întuneric. Întoarce-te cu fața spre o fereastră.');
        else if (st.light > 215) bad('light', 'E prea multă lumină. Evită soarele direct.');
        else setChip('light', 'good');

        if (mode === 'face') {
          if (me.detector) {
            var res = null;
            try { res = me.detector.detectForVideo(video, now); } catch (e) {}
            var f = res && res.detections && res.detections[0];
            if (!f) {
              bad('pos', 'Nu te vedem. Privește spre cameră.');
              setChip('look', 'wait');
            } else {
              var bb = f.boundingBox;
              var a = toView(bb.originX, bb.originY), b = toView(bb.originX + bb.width, bb.originY + bb.height);
              var w = b.x - a.x, h = b.y - a.y, cx = (a.x + b.x) / 2;
              if (w < 0.28) bad('pos', 'Apropie puțin telefonul.');
              else if (w > 0.54) bad('pos', 'Depărtează puțin telefonul.');
              else if (Math.abs(cx - 0.5) > 0.1) bad('pos', 'Centrează fața în oval.');
              else if (a.y - 0.5 * h < 0.1) bad('pos', 'Ridică puțin telefonul, să intre tot părul de sus.');
              else if (b.y > 0.92) bad('pos', 'Coboară puțin telefonul.');
              else setChip('pos', 'good');

              var kp = f.keypoints || [];
              if (kp.length >= 3) {
                var eyeMid = (kp[0].x + kp[1].x) / 2, eyeDist = Math.abs(kp[0].x - kp[1].x) || 1;
                var yaw = (kp[2].x - eyeMid) / eyeDist;
                var roll = Math.abs(kp[0].y - kp[1].y) / eyeDist;
                if (Math.abs(yaw) > 0.2 || roll > 0.2) bad('look', 'Privește drept în cameră, cu capul drept.');
                else setChip('look', 'good');
              } else setChip('look', 'good');
            }
          } else if (me.detectorFailed) {
            setChip('pos', 'good', 'Manual'); setChip('look', 'good', 'Manual');
            if (!tip) tip = 'Încadrează fața și părul în oval, apoi apasă butonul.';
            ok = false; // fără detector, poza se face doar manual
          } else {
            setChip('pos', 'wait'); setChip('look', 'wait');
            ok = false; if (!tip) tip = 'Pregătim verificarea poziției…';
          }
        } else {
          if (st.motion > 7) bad('still', 'Ține telefonul nemișcat.'); else setChip('still', 'good');
          if (st.sharp < 30) bad('sharp', 'Imaginea e neclară. Depărtează puțin telefonul sau atinge ecranul pentru focalizare.');
          else setChip('sharp', 'good');
        }

        if (guide) guide.setAttribute('stroke', ok ? '#7FD3A1' : '#fff');

        if (ok) {
          if (!me.goodSince) me.goodSince = now;
          if (!me.count && now - me.goodSince > 600) startCountdown();
          if (me.count) tip = 'Perfect! Nu te mișca.';
        } else {
          me.goodSince = 0;
          if (me.count) cancelCountdown();
        }
        tipEl.textContent = tip || M.start;
      }

      function startCountdown() {
        me.count = 3;
        countEl.textContent = '3'; beep(660);
        if (navigator.vibrate) try { navigator.vibrate(30); } catch (e) {}
        me.timer = setInterval(function () {
          if (!me.active) return clearInterval(me.timer);
          me.count--;
          if (me.count > 0) { countEl.textContent = String(me.count); beep(660); }
          else { clearInterval(me.timer); countEl.textContent = ''; capture(); }
        }, 800);
      }

      function cancelCountdown() {
        clearInterval(me.timer); me.count = 0; countEl.textContent = '';
      }

      function capture() {
        if (!me.active || !video.videoWidth) return;
        var vw = video.videoWidth, vh = video.videoHeight, MAX = 1280;
        var k = Math.min(1, MAX / Math.max(vw, vh));
        var c = document.createElement('canvas');
        c.width = Math.round(vw * k); c.height = Math.round(vh * k);
        c.getContext('2d').drawImage(video, 0, 0, c.width, c.height);
        var url = c.toDataURL('image/jpeg', 0.88);
        beep(990, 0.12);
        if (navigator.vibrate) try { navigator.vibrate([20, 40, 20]); } catch (e) {}
        var fl = box.querySelector('[data-cam-flash]');
        fl.classList.add('is-on');
        setTimeout(function () { fl.classList.remove('is-on'); }, 30);
        me.active = false;
        state.photos[slotIdx] = { preview: url, data: url.split(',')[1], media_type: 'image/jpeg' };
        track('hair_analysis_photo', { slot: slotIdx, source: 'camera' });
        setTimeout(function () { renderPhotos(); }, 380);
      }
    }


    /* ---------- Analiză vizuală locală: punctele feței + masca părului (rulează în browser) ---------- */
    var MP_LM = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';
    var MP_HAIR = 'https://storage.googleapis.com/mediapipe-models/image_segmenter/hair_segmenter/float32/latest/hair_segmenter.tflite';
    var HAIR_VAL = 1; // în masca modelului hair_segmenter: 0 = fundal, 1 = păr
    var ZKEYS = ['scalp', 'density', 'strength', 'hydration'];
    var ZSHORT = { scalp: 'Scalp', density: 'Densitate', strength: 'Rezistență', hydration: 'Hidratare' };
    var ZPLACE = { scalp: 'Rădăcini', density: 'Linia părului', strength: 'Lungimi', hydration: 'Vârfuri' };
    var visTasksP = null;

    function loadVisTasks() {
      if (visTasksP) return visTasksP;
      visTasksP = importVision().then(function (v) {
        return v.FilesetResolver.forVisionTasks(MP_BASE + '/wasm').then(function (files) {
          var lm = v.FaceLandmarker.createFromOptions(files, {
            baseOptions: { modelAssetPath: MP_LM, delegate: 'CPU' }, runningMode: 'IMAGE', numFaces: 1
          }).catch(function () { return null; });
          var hs = v.ImageSegmenter.createFromOptions(files, {
            baseOptions: { modelAssetPath: MP_HAIR, delegate: 'CPU' }, runningMode: 'IMAGE',
            outputCategoryMask: true, outputConfidenceMasks: false
          }).catch(function () { return null; });
          return Promise.all([lm, hs]).then(function (a) { return { v: v, lm: a[0], hs: a[1] }; });
        });
      });
      visTasksP.catch(function () { visTasksP = null; });
      return visTasksP;
    }

    function loadImg(src) {
      return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; });
    }

    function analyzePhoto(p) {
      if (p._vis) return p._vis;
      var tasks = new Promise(function (res) {
        loadVisTasks().then(res, function () { res(null); });
        setTimeout(function () { res(null); }, 20000);
      });
      p._vis = Promise.all([loadImg(p.preview), tasks]).then(function (a) {
        var img = a[0], T = a[1];
        var out = { img: img, iw: img.naturalWidth, ih: img.naturalHeight, pts: null, tess: null, mask: null };
        if (T && T.lm) try {
          var r = T.lm.detect(img);
          if (r && r.faceLandmarks && r.faceLandmarks[0]) { out.pts = r.faceLandmarks[0]; out.tess = T.v.FaceLandmarker.FACE_LANDMARKS_TESSELATION; }
        } catch (e) {}
        if (T && T.hs) try {
          var sr = T.hs.segment(img), m = sr && sr.categoryMask;
          if (m) { out.mask = { w: m.width, h: m.height, d: m.getAsUint8Array().slice() }; m.close(); }
        } catch (e) {}
        out.grid = buildZones(out);
        return out;
      });
      return p._vis;
    }

    // Împarte părul vizibil în 4 zone, raportat la față: rădăcini (sus), linia părului + tâmple, lungimi, vârfuri
    function buildZones(o) {
      var G = 220, GH = Math.max(1, Math.round(G * o.ih / o.iw));
      var cells = new Uint8Array(G * GH), hair = new Uint8Array(G * GH);
      var f = null, pts = o.pts;
      if (pts) {
        var top = pts[10].y, chin = pts[152].y, l = pts[234].x, r = pts[454].x;
        f = { top: top, chin: chin, h: chin - top, cx: (l + r) / 2, w: r - l, eye: (pts[159].y + pts[386].y) / 2 };
      }
      var x, y, i, nx, ny, n = 0;
      // 1) masca părului (sau o formă aproximativă, dacă nu avem mască)
      if (o.mask) {
        var M = o.mask, hairVal = HAIR_VAL;
        for (y = 0; y < GH; y++) for (x = 0; x < G; x++) {
          var mx = Math.min(M.w - 1, Math.floor((x + .5) / G * M.w)), my = Math.min(M.h - 1, Math.floor((y + .5) / GH * M.h));
          var v = M.d[my * M.w + mx];
          if (v === hairVal) hair[y * G + x] = 1;
        }
      } else if (f) {
        for (y = 0; y < GH; y++) for (x = 0; x < G; x++) {
          nx = (x + .5) / G; ny = (y + .5) / GH;
          var ex = (nx - f.cx) / (f.w * .66), ey = (ny - (f.top + f.h * .18)) / (f.h * .52);
          var fx = (nx - f.cx) / (f.w * .5), fy = (ny - (f.top + f.chin) / 2) / (f.h * .5);
          if (ex * ex + ey * ey < 1 && fx * fx + fy * fy > .86 && ny < f.eye) hair[y * G + x] = 1;
        }
      } else return null;
      // 2) atribuim fiecare celulă unei zone
      var ys = [];
      for (i = 0; i < hair.length; i++) if (hair[i]) { n++; ys.push(Math.floor(i / G)); }
      if (n < 30) return null;
      ys.sort(function (a, b) { return a - b; });
      var q = function (k) { return ys[Math.min(ys.length - 1, Math.floor(ys.length * k))]; };
      var q1 = q(.3), q2 = q(.55), q3 = q(.82);
      for (y = 0; y < GH; y++) for (x = 0; x < G; x++) {
        i = y * G + x; if (!hair[i]) continue;
        ny = (y + .5) / GH;
        var z;
        if (f) z = ny > f.chin + .02 ? 4 : ny > f.eye ? 3 : ny >= f.top - f.h * .2 ? 2 : 1;
        else z = y < q1 ? 1 : y < q2 ? 2 : y < q3 ? 3 : 4;
        cells[i] = z;
      }
      // 3) centrul fiecărei zone (pentru etichete) + puncte pentru animația de scanare
      var sx = [0, 0, 0, 0, 0], sy = [0, 0, 0, 0, 0], cnt = [0, 0, 0, 0, 0], spark = [];
      for (i = 0; i < cells.length; i++) if (cells[i]) {
        var zz = cells[i], cx = i % G, cy = Math.floor(i / G);
        sx[zz] += cx; sy[zz] += cy; cnt[zz]++;
        if (Math.random() < .07) spark.push([(cx + Math.random()) / G, (cy + Math.random()) / GH, Math.random() * 6.28]);
      }
      var cent = {};
      ZKEYS.forEach(function (k, j) { var zi = j + 1; if (cnt[zi] > n * .015) cent[k] = [(sx[zi] / cnt[zi] + .5) / G, (sy[zi] / cnt[zi] + .5) / GH]; });
      return { G: G, GH: GH, cells: cells, hair: hair, cent: cent, spark: spark, count: cnt };
    }

    function zoneColor(v) { return v >= 75 ? [76, 195, 138] : v >= 55 ? [242, 179, 75] : [240, 86, 110]; }
    function rgb(c, a) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }

    // Un canvas mic pentru fiecare zonă, colorat după scor (marginile mai intense)
    function zoneLayers(grid, scores) {
      var out = {};
      ZKEYS.forEach(function (k, j) {
        var zi = j + 1, G = grid.G, GH = grid.GH, c = document.createElement('canvas');
        c.width = G; c.height = GH;
        var ctx = c.getContext('2d'), id = ctx.createImageData(G, GH), col = zoneColor(scores[k] == null ? 60 : scores[k]), any = false;
        for (var y = 0; y < GH; y++) for (var x = 0; x < G; x++) {
          var i = y * G + x; if (grid.cells[i] !== zi) continue;
          any = true;
          var edge = x === 0 || y === 0 || x === G - 1 || y === GH - 1 || grid.cells[i - 1] !== zi || grid.cells[i + 1] !== zi || grid.cells[i - G] !== zi || grid.cells[i + G] !== zi;
          id.data[i * 4] = col[0]; id.data[i * 4 + 1] = col[1]; id.data[i * 4 + 2] = col[2]; id.data[i * 4 + 3] = edge ? 235 : 105;
        }
        ctx.putImageData(id, 0, 0);
        out[k] = any ? c : null;
      });
      return out;
    }

    function coverBox(iw, ih, W, H) {
      var s = Math.max(W / iw, H / ih), w = iw * s, h = ih * s;
      return { x: (W - w) / 2, y: (H - h) / 2, w: w, h: h };
    }

    function fitCanvas(cv) {
      var dpr = Math.min(2, window.devicePixelRatio || 1), W = cv.clientWidth, H = cv.clientHeight;
      if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
      var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return { ctx: ctx, W: W, H: H };
    }

    function corners(ctx, W, H) {
      var m = 14, L = 26;
      ctx.strokeStyle = 'rgba(255,255,255,.9)'; ctx.lineWidth = 2.5; ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(m, m + L); ctx.lineTo(m, m); ctx.lineTo(m + L, m);
      ctx.moveTo(W - m - L, m); ctx.lineTo(W - m, m); ctx.lineTo(W - m, m + L);
      ctx.moveTo(m, H - m - L); ctx.lineTo(m, H - m); ctx.lineTo(m + L, H - m);
      ctx.moveTo(W - m - L, H - m); ctx.lineTo(W - m, H - m); ctx.lineTo(W - m, H - m - L);
      ctx.stroke();
    }

    /* ---------- Submit ---------- */
    function submit() {
      renderLoading();
      track('hair_analysis_submit');
      var started = Date.now();
      var req;
      if (cfg.demo || !cfg.endpoint) {
        req = new Promise(function (res) { setTimeout(function () { res({ report: DEMO_REPORT }); }, 8800); });
      } else {
        var ctrl = window.AbortController ? new AbortController() : null;
        var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, 75000);
        req = fetch(cfg.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            answers: state.answers,
            images: state.photos.filter(Boolean).map(function (p) { return { data: p.data, media_type: p.media_type }; })
          }),
          signal: ctrl ? ctrl.signal : undefined
        }).then(function (r) {
          clearTimeout(to);
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) { var e = new Error(j.error || 'http'); e.status = r.status; throw e; }
            return j;
          });
        });
      }
      req.then(function (j) {
        if (!j || !j.report) throw new Error('empty');
        var wait = Math.max(0, 7600 - (Date.now() - started));
        setTimeout(function () {
          state.report = j.report;
          if (j.report.photo_quality === 'unusable') {
            renderPhotos(j.report.photo_note || 'Fotografia nu arată suficient de clar părul sau scalpul. Încearcă o altă fotografie, la lumină naturală.');
            return;
          }
          renderResult(j.report);
          track('hair_analysis_complete', { hair_score: j.report.hair_score, products: (j.report.products || []).map(function (p) { return p.key; }).join(',') });
        }, wait);
      }).catch(function (e) {
        var msg = 'Analiza nu a putut fi finalizată acum. Te rugăm să încerci din nou peste câteva momente.';
        if (e && e.status === 429) msg = 'Ai făcut mai multe analize într-un timp scurt. Încearcă din nou peste un minut.';
        if (e && e.status === 413) msg = 'Fotografiile sunt prea mari. Încearcă alte imagini.';
        if (e && e.name === 'AbortError') msg = 'Analiza durează mai mult decât de obicei. Te rugăm să încerci din nou.';
        renderPhotos(msg);
      });
    }

    function renderLoading() {
      var p = state.photos[0];
      render('<div class="sha-loading" aria-live="polite">' +
        '<div class="sha-scanbox">' +
          '<canvas data-ha-scan aria-hidden="true"></canvas>' +
          '<span class="sha-scan-tag"><i></i>Raport AI în curs de creare…</span>' +
          '<div class="sha-scan-msg" data-ha-msg>' + LOADING_MSGS[0] + '</div>' +
        '</div>' +
        '<div class="sha-lprog" aria-hidden="true"><span data-ha-prog></span></div>' +
        '<p class="sha-muted" style="font-size:14px;margin-top:12px">Durează de obicei 15–25 de secunde.</p>' +
      '</div>');
      var i = 0, el = stage.querySelector('[data-ha-msg]'), prog = stage.querySelector('[data-ha-prog]');
      var t = setInterval(function () {
        if (!document.body.contains(el)) return clearInterval(t);
        i = Math.min(i + 1, LOADING_MSGS.length - 1);
        el.textContent = LOADING_MSGS[i];
      }, 2600);
      var cv = stage.querySelector('[data-ha-scan]'), vis = null, img = null, t0 = performance.now(), maxY = 0;
      if (!p) return;
      loadImg(p.preview).then(function (im) { img = im; });
      analyzePhoto(p).then(function (v) { vis = v; }).catch(function () {});
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      (function frame(now) {
        if (!document.body.contains(cv)) return;
        var el2 = now - t0;
        // progres „orientativ”: ajunge la ~92% în 20s, apoi se termină la rezultat
        prog.style.width = (92 * (1 - Math.exp(-el2 / 8000))) + '%';
        var F = fitCanvas(cv), ctx = F.ctx, W = F.W, H = F.H;
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#1D1A16'; ctx.fillRect(0, 0, W, H);
        if (img) {
          var b = coverBox(img.naturalWidth, img.naturalHeight, W, H);
          ctx.drawImage(img, b.x, b.y, b.w, b.h);
          ctx.fillStyle = 'rgba(20,12,16,.28)'; ctx.fillRect(0, 0, W, H);
          var period = 2800, ph = (el2 % period) / period, pp = ph < .5 ? ph * 2 : 2 - ph * 2;
          var ease = pp < .5 ? 2 * pp * pp : 1 - Math.pow(-2 * pp + 2, 2) / 2;
          var sy = reduce ? H * .5 : ease * H;
          maxY = el2 > period * .5 ? H : Math.max(maxY, sy);
          var P = function (nx, ny) { return [b.x + nx * b.w, b.y + ny * b.h]; };
          if (vis && vis.pts) {
            // plasa feței
            ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = .6; ctx.beginPath();
            var pts = vis.pts, tess = vis.tess || [];
            for (var k = 0; k < tess.length; k++) {
              var a1 = pts[tess[k].start], a2 = pts[tess[k].end]; if (!a1 || !a2) continue;
              var q1 = P(a1.x, a1.y), q2 = P(a2.x, a2.y);
              if (q1[1] > maxY && q2[1] > maxY) continue;
              ctx.moveTo(q1[0], q1[1]); ctx.lineTo(q2[0], q2[1]);
            }
            ctx.stroke();
            for (var j = 0; j < pts.length; j += 2) {
              var q = P(pts[j].x, pts[j].y); if (q[1] > maxY) continue;
              var near = Math.abs(q[1] - sy) < 18;
              ctx.fillStyle = near ? 'rgba(255,120,170,1)' : 'rgba(255,255,255,.75)';
              ctx.beginPath(); ctx.arc(q[0], q[1], near ? 1.9 : 1.05, 0, 6.283); ctx.fill();
            }
          }
          if (vis && vis.grid) {
            // „scântei” pe păr
            var sp = vis.grid.spark;
            for (var m = 0; m < sp.length; m++) {
              var s2 = P(sp[m][0], sp[m][1]); if (s2[1] > maxY) continue;
              var al = .25 + .75 * Math.max(0, Math.sin(el2 / 260 + sp[m][2]));
              var nr = Math.abs(s2[1] - sy) < 22;
              ctx.fillStyle = 'rgba(255,' + (nr ? 150 : 110) + ',' + (nr ? 190 : 160) + ',' + (nr ? 1 : al * .85) + ')';
              ctx.beginPath(); ctx.arc(s2[0], s2[1], nr ? 2 : 1.3, 0, 6.283); ctx.fill();
            }
          }
          // linia de scanare
          var g = ctx.createLinearGradient(0, sy - 70, 0, sy);
          g.addColorStop(0, 'rgba(255,105,160,0)'); g.addColorStop(1, 'rgba(255,105,160,.35)');
          ctx.fillStyle = g; ctx.fillRect(0, sy - 70, W, 70);
          ctx.save(); ctx.shadowColor = 'rgba(255,90,150,.95)'; ctx.shadowBlur = 14;
          ctx.fillStyle = '#FF6FA6'; ctx.fillRect(0, sy - 1.5, W, 3); ctx.restore();
        }
        corners(ctx, W, H);
        requestAnimationFrame(frame);
      })(performance.now());
    }

    /* ---------- Result ---------- */
    function barColor(v) { return v >= 75 ? '#4F6B4F' : v >= 55 ? '#B07A3E' : '#9E4430'; }

    function renderResult(r) {
      var R = 72, C = 2 * Math.PI * R;
      var prods = (r.products || []).map(function (p) { return Object.assign({}, p, { data: cfg.products[p.key] }); }).filter(function (p) { return p.data; });
      var buyable = prods.filter(function (p) { return p.data.available !== false && p.data.variant; });
      var total = buyable.reduce(function (s, p) { return s + (p.data.price_cents || 0); }, 0);
      // Produsele se văd doar după ce clientul lasă adresa de email (o singură dată pe dispozitiv)
      var gated = cfg.email !== false && prods.length > 0 && !hasEmail();

      var html =
        '<div class="sha-hero">' +
          '<div class="sha-hero-media">' +
            '<canvas data-ha-hero aria-hidden="true"></canvas>' +
            '<div class="sha-hero-pins" data-ha-pins></div>' +
            '<div class="sha-hero-chips">' +
              '<span class="sha-hchip sha-hchip--main">Sănătatea părului <b><span data-ha-num>0</span>%</b></span>' +
              (r.priority && METRIC_LABELS[r.priority] ? '<span class="sha-hchip">De îmbunătățit: ' + esc(ZSHORT[r.priority]) + '</span>' : '') +
            '</div>' +
            '<div class="sha-hero-badges" role="group" aria-label="Scorul pe zone">' + ZKEYS.map(function (k) {
              var m = (r.metrics || []).filter(function (x) { return x.key === k; })[0]; if (!m) return '';
              var v = Math.max(0, Math.min(100, m.score | 0)), c = zoneColor(v), RR = 21, CC = 2 * Math.PI * RR;
              return '<button type="button" class="sha-zb" data-ha-zone="' + k + '" aria-pressed="false">' +
                '<span class="sha-zb-ring"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="' + RR + '" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="4"/>' +
                '<circle class="sha-zb-val" cx="25" cy="25" r="' + RR + '" fill="none" stroke="' + rgb(c, 1) + '" stroke-width="4" stroke-linecap="round" stroke-dasharray="' + CC + '" stroke-dashoffset="' + CC + '" data-off="' + (CC * (1 - v / 100)) + '"/></svg>' +
                '<b>' + v + '%</b></span><span class="sha-zb-l">' + esc(ZSHORT[k]) + '</span></button>';
            }).join('') + '</div>' +
          '</div>' +
          '<div class="sha-hero-text">' +
            '<div class="sha-kicker">Rezultatul analizei tale</div>' +
            '<h2 class="sha-res-title">' + esc(r.headline) + '</h2>' +
            '<p class="sha-res-sum">' + esc(r.summary) + '</p>' +
            '<div class="sha-zone-note" data-ha-znote><span class="sha-muted">Atinge un procent de pe fotografie ca să vezi zona și ce înseamnă.</span></div>' +
            (prods.length ? '<button type="button" class="sha-btn sha-btn--accent sha-hero-cta" data-ha-goprods>Vezi ce produse sunt pentru tine!</button>' : '') +
          '</div>' +
        '</div>' +
        (r.photo_quality === 'limited' && r.photo_note ? '<div class="sha-note sha-note--info">' + ICON.info + '<span>' + esc(r.photo_note) + '</span></div>' : '') +
        (r.see_doctor ? '<div class="sha-note sha-note--warn" role="note">' + ICON.warn + '<span><strong>Recomandarea noastră:</strong> ' + esc(r.doctor_note || 'Pentru ce am observat, îți recomandăm să discuți și cu un medic dermatolog.') + '</span></div>' : '') +

        '<div class="sha-section"><h3>Scorul pe zone</h3><p class="sha-muted">Începe cu zona marcată, apoi construiește rutina treptat.</p>' +
          '<div class="sha-metrics">' + (r.metrics || []).map(function (m) {
            var prio = m.key === r.priority;
            return '<div class="sha-metric' + (prio ? ' sha-metric--prio' : '') + '">' +
              (prio ? '<span class="sha-badge">Începe de aici</span>' : '') +
              '<div class="sha-metric-top"><span>' + esc(METRIC_LABELS[m.key] || m.key) + '</span><b>' + (m.score | 0) + '</b></div>' +
              '<div class="sha-bar"><span data-w="' + (m.score | 0) + '" style="background:' + barColor(m.score) + '"></span></div>' +
              '<p>' + esc(m.note) + '</p></div>';
          }).join('') + '</div>' +
        '</div>' +

        ((r.observations || []).length ? '<div class="sha-section"><h3>Ce am observat</h3><ul class="sha-obs">' +
          r.observations.map(function (o) { return '<li>' + esc(o) + '</li>'; }).join('') + '</ul></div>' : '') +

        (gated ? gateHtml(prods) : '') +
        '<div data-ha-locked' + (gated ? ' hidden' : '') + '>' +
        (prods.length ? '<div class="sha-section" data-ha-prods><h3>Ritualul tău SORAS</h3><p class="sha-muted">Ales pentru ce ne-ai spus și ce am văzut în fotografii.</p>' +
          '<div class="sha-products">' + prods.map(function (p, i) {
            var d = p.data, ok = d.available !== false && d.variant;
            return '<article class="sha-prod">' +
              '<a href="' + esc(d.url) + '"><img class="sha-prod-img" src="' + esc(d.image) + '" alt="' + esc(d.title) + '" loading="lazy" width="128" height="128"></a>' +
              '<div><div class="sha-prod-n">Pasul ' + (i + 1) + '</div>' +
                '<h4><a href="' + esc(d.url) + '">' + esc(d.title) + '</a></h4>' +
                '<div class="sha-price">' + esc(d.price) + (d.compare ? '<s>' + esc(d.compare) + '</s>' : '') + '</div>' +
                '<dl><div><dt>De ce: </dt><dd>' + esc(p.why) + '</dd></div><div><dt>Cum: </dt><dd>' + esc(p.how) + '</dd></div></dl>' +
                (ok ? '<button type="button" class="sha-btn sha-btn--sm" data-ha-add="' + esc(d.variant) + '">Adaugă în coș</button>'
                    : '<button type="button" class="sha-btn sha-btn--sm sha-btn--ghost" disabled>Momentan indisponibil</button>') +
              '</div></article>';
          }).join('') + '</div>' +
          (buyable.length > 1 ? '<div class="sha-bundle"><div><p>Tot ritualul</p><strong>' + esc(formatMoney(total, cfg.moneyFormat)) + '</strong></div>' +
            '<button type="button" class="sha-btn" data-ha-addall>Adaugă tot ritualul în coș</button></div>' : '') +
        '</div>' : '') +

        lashUpsell(r, prods) +

        ((r.routine || []).length ? '<div class="sha-section"><h3>Cum îl folosești</h3><ol class="sha-routine">' +
          r.routine.map(function (s) { return '<li><b>' + esc(s.when) + '</b>' + esc(s.action) + '</li>'; }).join('') + '</ol>' +
          (r.expectation ? '<p class="sha-expect">' + esc(r.expectation) + '</p>' : '') + '</div>' : '') +
        '</div>' +

        (cfg.email !== false && !gated && !hasEmail() ? '<div class="sha-email"><h3>Primește ritualul pe email</h3>' +
          '<p class="sha-muted">Îți trimitem rezultatul și pașii, ca să-i ai la îndemână. Plus sfaturi de îngrijire de la SORAS.</p>' +
          '<form data-ha-email novalidate><label class="sha-sr" for="sha-email-in">Adresa de email</label><input id="sha-email-in" type="email" name="email" required autocomplete="email" placeholder="Adresa ta de email">' +
          '<button type="submit" class="sha-btn sha-btn--accent">Trimite-mi ritualul</button></form>' +
          '<small>Te poți dezabona oricând, cu un click.</small><div data-ha-email-msg></div></div>' : '') +

        '<p class="sha-disclaimer">Analiza este orientativă, are scop cosmetic și poate fi influențată de lumină și calitatea camerei. Nu înlocuiește consultul unui medic dermatolog.</p>' +
        '<div class="sha-restart"><button type="button" class="sha-link" data-ha-restart>Refă analiza</button></div>';

      render(html);

      // Animații: scorul, barele, cercurile de pe fotografie
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var score = Math.max(0, Math.min(100, r.hair_score | 0));
          stage.querySelectorAll('.sha-bar span').forEach(function (b) { b.style.width = b.getAttribute('data-w') + '%'; });
          stage.querySelectorAll('.sha-zb-val').forEach(function (c) { c.style.strokeDashoffset = c.getAttribute('data-off'); });
          var num = stage.querySelector('[data-ha-num]'), t0 = performance.now();
          var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce) { num.textContent = score; return; }
          (function tick(now) {
            var k = Math.min(1, (now - t0) / 1300);
            num.textContent = Math.round(score * (1 - Math.pow(1 - k, 3)));
            if (k < 1) requestAnimationFrame(tick);
          })(t0);
        });
      });
      heroMap(r);
      var gp = stage.querySelector('[data-ha-goprods]');
      if (gp) gp.addEventListener('click', function () {
        var lk = stage.querySelector('[data-ha-locked]');
        var t = lk && lk.hidden ? stage.querySelector('[data-ha-gate]') : stage.querySelector('[data-ha-prods]'); if (!t) return;
        if (lk && lk.hidden) { var gi = t.querySelector('input[type=email]'); if (gi) setTimeout(function () { gi.focus({ preventScroll: true }); }, 500); }
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
        track('hair_analysis_go_products');
      });

      stage.querySelectorAll('[data-ha-add]').forEach(function (b) {
        b.addEventListener('click', function () { addToCart([+b.getAttribute('data-ha-add')], b); });
      });
      var all = stage.querySelector('[data-ha-addall]');
      if (all) all.addEventListener('click', function () { addToCart(buyable.map(function (p) { return +p.data.variant; }), all); });
      stage.querySelector('[data-ha-restart]').addEventListener('click', function () {
        state.answers = { concerns: [], treatments: [] }; state.photos = [null, null]; state.report = null; go(0);
      });
      var form = stage.querySelector('[data-ha-email]');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); subscribe(form, r, prods); });
      var gform = stage.querySelector('[data-ha-gate-form]');
      if (gform) gform.addEventListener('submit', function (e) {
        e.preventDefault();
        subscribe(gform, r, prods, function () {
          var gate = stage.querySelector('[data-ha-gate]'), lk = stage.querySelector('[data-ha-locked]');
          lk.hidden = false; lk.classList.add('sha-fade');
          gate.parentNode.removeChild(gate);
          var t = stage.querySelector('[data-ha-prods]') || lk;
          window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
          toast('Gata! Ți-am trimis ritualul și pe email.');
          track('hair_analysis_unlock');
        });
      });
    }

    function hasEmail() { try { return !!localStorage.getItem('sha_email'); } catch (e) { return false; } }

    // Ecranul care cere emailul înainte de produse: miniaturi estompate + formular
    function gateHtml(prods) {
      return '<div class="sha-section sha-gate" data-ha-gate>' +
        '<div class="sha-gate-thumbs" aria-hidden="true">' + prods.slice(0, 4).map(function (p) {
          return '<img src="' + esc(p.data.image) + '" alt="" loading="lazy">';
        }).join('') + '<span class="sha-gate-lock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg></span></div>' +
        '<div class="sha-kicker">Ritualul tău SORAS e gata</div>' +
        '<h3>Vezi produsele potrivite pentru tine</h3>' +
        '<p class="sha-muted">Am ales ' + prods.length + (prods.length === 1 ? ' produs' : ' produse') + ' și pașii exacți de folosire, după analiza ta. Lasă-ne adresa de email ca să le vezi acum și să primești ritualul și pe email.</p>' +
        '<form data-ha-gate-form novalidate><label class="sha-sr" for="sha-gate-in">Adresa de email</label>' +
          '<input id="sha-gate-in" type="email" name="email" required autocomplete="email" inputmode="email" placeholder="Adresa ta de email">' +
          '<button type="submit" class="sha-btn sha-btn--accent">Vezi ritualul meu</button></form>' +
        '<div data-ha-email-msg></div>' +
        '<small>Fără spam. Te poți dezabona oricând, cu un click.</small>' +
      '</div>';
    }

    // Bonus pentru gene: uleiul de ricin, când în selfie genele par rare sau scurte
    function lashUpsell(r, prods) {
      var L = r.lashes, d = cfg.products.castor;
      if (!L || !L.sparse || !d || prods.some(function (p) { return p.key === 'castor'; })) return '';
      var ok = d.available !== false && d.variant;
      return '<div class="sha-lash">' +
        '<div class="sha-lash-tag">Bonus pentru gene</div>' +
        '<article class="sha-prod sha-prod--lash">' +
          '<a href="' + esc(d.url) + '"><img class="sha-prod-img" src="' + esc(d.image) + '" alt="' + esc(d.title) + '" loading="lazy" width="128" height="128"></a>' +
          '<div><h4><a href="' + esc(d.url) + '">' + esc(d.title) + '</a></h4>' +
            '<div class="sha-price">' + esc(d.price) + (d.compare ? '<s>' + esc(d.compare) + '</s>' : '') + '</div>' +
            '<p class="sha-lash-note">' + esc(L.note || 'Am observat că genele tale pot arăta mai pline. Uleiul de ricin, aplicat seara cu periuța, le hrănește de la rădăcină.') + '</p>' +
            '<p class="sha-lash-how"><b>Cum:</b> seara, pe genele curate, o picătură pe periuță, de la rădăcină spre vârf. Rezultate vizibile în 4–8 săptămâni.</p>' +
            (ok ? '<button type="button" class="sha-btn sha-btn--sm sha-btn--accent" data-ha-add="' + esc(d.variant) + '">Adaugă în coș</button>' : '') +
          '</div></article></div>';
    }

    // Fotografia clientului cu zonele părului colorate după scor
    function heroMap(r) {
      var cv = stage.querySelector('[data-ha-hero]'), pinsEl = stage.querySelector('[data-ha-pins]'), note = stage.querySelector('[data-ha-znote]');
      var p = state.photos[0]; if (!cv || !p) return;
      var scores = {}, notes = {};
      (r.metrics || []).forEach(function (m) { scores[m.key] = m.score | 0; notes[m.key] = m.note; });
      var vis = null, img = null, layers = null, active = null, t0 = performance.now(), tl = 0, lastPins = '';
      loadImg(p.preview).then(function (im) { img = im; });
      analyzePhoto(p).then(function (v) { vis = v; if (v.grid) { layers = zoneLayers(v.grid, scores); tl = performance.now(); } }).catch(function () {});
      var btns = stage.querySelectorAll('[data-ha-zone]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-ha-zone');
          active = active === k ? null : k;
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-ha-zone') === active); });
          if (active) {
            var c = zoneColor(scores[active]);
            note.innerHTML = '<div class="sha-zone-note-h"><i style="background:' + rgb(c, 1) + '"></i>' + esc(METRIC_LABELS[active]) + ' · <b>' + scores[active] + '%</b>' +
              (active === r.priority ? '<span class="sha-badge">Începe de aici</span>' : '') + '</div><p>' + esc(notes[active] || '') + '</p>';
            track('hair_analysis_zone', { zone: active });
          } else note.innerHTML = '<span class="sha-muted">Atinge un procent de pe fotografie ca să vezi zona și ce înseamnă.</span>';
        });
      });
      (function frame(now) {
        if (!document.body.contains(cv)) return;
        var F = fitCanvas(cv), ctx = F.ctx, W = F.W, H = F.H, el = now - t0;
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = '#1D1A16'; ctx.fillRect(0, 0, W, H);
        if (img) {
          var b = coverBox(img.naturalWidth, img.naturalHeight, W, H);
          ctx.drawImage(img, b.x, b.y, b.w, b.h);
          if (layers) {
            // apariție de sus în jos, apoi pulsează zona aleasă
            var reveal = Math.min(1, (now - tl) / 1400), clipH = b.y + b.h * reveal;
            ctx.save(); ctx.beginPath(); ctx.rect(0, 0, W, clipH); ctx.clip();
            ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
            if ('filter' in ctx) ctx.filter = 'blur(' + (b.w / 220 * .7).toFixed(2) + 'px)';
            ZKEYS.forEach(function (k) {
              if (!layers[k]) return;
              var a = !active ? .62 : active === k ? .72 + .25 * Math.sin(el / 320) : .1;
              ctx.globalAlpha = Math.max(0, a); ctx.drawImage(layers[k], b.x, b.y, b.w, b.h);
            });
            ctx.restore(); ctx.globalAlpha = 1; if ('filter' in ctx) ctx.filter = 'none';
            if (reveal < 1) {
              ctx.save(); ctx.shadowColor = 'rgba(255,90,150,.9)'; ctx.shadowBlur = 12;
              ctx.fillStyle = '#FF6FA6'; ctx.fillRect(0, clipH - 1.5, W, 3); ctx.restore();
            }
            // etichetele zonelor, poziționate pe fotografie
            var html = '';
            if (reveal >= 1) ZKEYS.forEach(function (k) {
              var c = vis.grid.cent[k]; if (!c || scores[k] == null || (active && active !== k)) return;
              var x = b.x + c[0] * b.w, y = b.y + c[1] * b.h;
              if (x < 40 || x > W - 40 || y < 50 || y > H - 110) return;
              html += '<span class="sha-pin" style="left:' + x.toFixed(0) + 'px;top:' + y.toFixed(0) + 'px"><i style="background:' + rgb(zoneColor(scores[k]), 1) + '"></i>' + esc(ZPLACE[k]) + ' ' + scores[k] + '%</span>';
            });
            if (html !== lastPins) { pinsEl.innerHTML = html; lastPins = html; }
          }
        }
        corners(ctx, W, H);
        requestAnimationFrame(frame);
      })(performance.now());
    }

    /* ---------- Cart ---------- */
    function addToCart(ids, btn) {
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Se adaugă…';
      var done = function () {
        btn.disabled = false; btn.textContent = label;
        toast(ids.length > 1 ? 'Ritualul a fost adăugat în coș' : 'Produsul a fost adăugat în coș', { href: routesRoot + 'cart', label: 'Vezi coșul' });
        track('hair_analysis_add_to_cart', { items: ids.length });
      };
      if (cfg.demo) { setTimeout(done, 500); return; }
      fetch(routesRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        done();
        // anunțăm tema să-și actualizeze coșul / numărul de produse
        ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
        fetch(routesRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span, .header__cart-count, .cart-count-number').forEach(function (el) { el.textContent = c.item_count; });
        }).catch(function () {});
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
        toast('Nu am putut adăuga în coș. Încearcă din nou.');
      });
    }

    /* ---------- Email ---------- */
    function subscribe(form, r, prods, onOk) {
      var input = form.querySelector('input[type=email]');
      var msg = form.parentNode.querySelector('[data-ha-email-msg]');
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.innerHTML = '<div class="sha-err">Te rugăm să scrii o adresă de email validă.</div>'; input.focus(); return; }
      var btn = form.querySelector('button'); btn.disabled = true;

      var props = {
        hair_score: r.hair_score,
        hair_headline: r.headline,
        hair_priority: r.priority,
        hair_products: prods.map(function (p) { return p.data.title; }).join(' | '),
        hair_routine: (r.routine || []).map(function (s) { return s.when + ': ' + s.action; }).join(' || '),
        hair_analysis_date: new Date().toISOString().slice(0, 10)
      };
      var jobs = [];

      if (cfg.demo) jobs.push(new Promise(function (res) { setTimeout(res, 500); }));

      // 1) Klaviyo: abonare la listă (dacă e configurat ID-ul listei)
      if (!cfg.demo && cfg.klaviyo && cfg.klaviyo.publicKey && cfg.klaviyo.listId) {
        jobs.push(fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyo.publicKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: 'Analiza parului',
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          }, relationships: { list: { data: { type: 'list', id: cfg.klaviyo.listId } } } } })
        }));
      }
      // 2) Klaviyo: eveniment pentru flow-ul care trimite ritualul
      if (!cfg.demo && window.klaviyo && typeof window.klaviyo.push === 'function') {
        try {
          window.klaviyo.push(['identify', { email: email }]);
          window.klaviyo.push(['track', 'Hair Analysis Completed', Object.assign({}, props, {
            products: prods.map(function (p) { return { title: p.data.title, url: location.origin + p.data.url, image: p.data.image, why: p.why, how: p.how }; }),
            routine: r.routine, summary: r.summary
          })]);
        } catch (e) {}
      }
      // 3) Fără Klaviyo: clientul e salvat în Shopify cu tag-ul "analiza-par"
      if (!cfg.demo && !(cfg.klaviyo && cfg.klaviyo.listId)) {
        var fd = new FormData();
        fd.append('form_type', 'customer'); fd.append('utf8', '✓');
        fd.append('contact[email]', email); fd.append('contact[tags]', 'newsletter,analiza-par');
        jobs.push(fetch(routesRoot + 'contact', { method: 'POST', body: fd, credentials: 'same-origin' }));
      }

      var unlock = function () { try { localStorage.setItem('sha_email', '1'); } catch (e) {} if (onOk) onOk(); };
      Promise.all(jobs).then(function () {
        track('hair_analysis_email', {});
        if (onOk) return unlock();
        unlock();
        form.style.display = 'none';
        msg.innerHTML = '<p class="sha-email-ok">Gata! Verifică-ți inboxul în câteva minute.</p>';
      }).catch(function () {
        // nu ținem clientul blocat dacă rețeaua dă eroare: îi arătăm oricum produsele
        if (onOk) return unlock();
        btn.disabled = false;
        msg.innerHTML = '<div class="sha-err">Nu am putut trimite acum. Încearcă din nou.</div>';
      });
    }

    renderIntro();
  }

  // Stilurile pentru scanare și harta părului (injectate o singură dată)
  var MAP_CSS = ".sha-scanbox{position:relative;width:min(380px,100%);aspect-ratio:3/4;margin:0 auto;border-radius:22px;overflow:hidden;background:#1d1a16;box-shadow:0 18px 50px #1d1a1638}.sha-scanbox canvas,.sha-hero-media canvas{position:absolute;inset:0;width:100%;height:100%;display:block}.sha-scan-tag{position:absolute;top:22px;left:50%;transform:translate(-50%);display:inline-flex;align-items:center;gap:8px;white-space:nowrap;padding:8px 14px;border-radius:999px;background:#ffffffeb;color:#1d1a16;font-size:13px;font-weight:600;box-shadow:0 4px 14px #0000002e}.sha-scan-tag i{width:8px;height:8px;border-radius:50%;background:#ff5c98;box-shadow:0 0 #ff5c9899;animation:sha-ping 1.4s infinite}@keyframes sha-ping{70%{box-shadow:0 0 0 8px #ff5c9800}to{box-shadow:0 0 #ff5c9800}}.sha-scan-msg{position:absolute;left:16px;right:16px;bottom:20px;padding:12px 14px;border-radius:14px;background:#1d1a168c;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);color:#fff;font-family:var(--sha-head);font-size:22px;line-height:1.2}.sha-lprog{width:min(380px,100%);height:5px;margin:18px auto 0;border-radius:5px;background:var(--sha-line);overflow:hidden}.sha-lprog span{display:block;height:100%;width:0;border-radius:5px;background:linear-gradient(90deg,#ff7eb0,#ff4f8e)}.sha-hero{display:grid;gap:26px;align-items:center}@media (min-width:760px){.sha-hero{grid-template-columns:minmax(0,400px) 1fr;gap:40px}}.sha-hero-media{position:relative;width:100%;max-width:400px;margin:0 auto;aspect-ratio:3/4;border-radius:22px;overflow:hidden;background:#1d1a16;box-shadow:0 18px 50px #1d1a1638}.sha-hero-media:after{content:\"\";position:absolute;left:0;right:0;bottom:0;height:42%;background:linear-gradient(180deg,#0f0a0800,#0f0a08c7);pointer-events:none}.sha-hero-chips{position:absolute;top:16px;left:14px;right:14px;display:flex;flex-wrap:wrap;gap:8px;justify-content:center;z-index:2}.sha-hchip{display:inline-flex;align-items:baseline;gap:4px;padding:8px 13px;border-radius:999px;background:#ffffffed;color:#1d1a16;font-size:13px;font-weight:600;box-shadow:0 4px 14px #00000029}.sha-hchip--main b{font-size:15px}.sha-hero-pins{position:absolute;inset:0;pointer-events:none;z-index:1}.sha-pin{position:absolute;transform:translate(-50%,-50%);display:inline-flex;align-items:center;gap:6px;white-space:nowrap;padding:5px 10px;border-radius:999px;background:#1d1a16b8;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);color:#fff;font-size:12px;font-weight:600;animation:sha-pin-in .45s ease both}.sha-pin i{width:8px;height:8px;border-radius:50%}@keyframes sha-pin-in{0%{opacity:0;transform:translate(-50%,-30%)}}.sha-hero-badges{position:absolute;left:8px;right:8px;bottom:14px;display:grid;grid-template-columns:repeat(4,1fr);gap:4px;z-index:2}.sha .sha-zb,.sha .sha-zb:hover,.sha .sha-zb:focus,.sha .sha-zb:active{all:unset;box-sizing:border-box;display:flex!important;flex-direction:column;align-items:center;gap:6px;padding:6px 2px;border-radius:14px;cursor:pointer;color:#fff!important;background:transparent!important;text-transform:none!important;letter-spacing:normal!important;-webkit-tap-highlight-color:transparent}.sha .sha-zb[aria-pressed=true]{background:#ffffff29!important}.sha .sha-zb:focus-visible{outline:2px solid #fff;outline-offset:1px}.sha-zb-ring{position:relative;width:54px;height:54px}.sha-zb-ring svg{width:100%;height:100%;transform:rotate(-90deg)}.sha-zb-val{transition:stroke-dashoffset 1.3s cubic-bezier(.2,.7,.2,1)}.sha-zb-ring b{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#fff}.sha-zb-l{font-size:12px;font-weight:600;line-height:1.1;text-align:center;color:#fff}.sha-zone-note{margin-top:18px;padding:14px 16px;border:1px solid var(--sha-line);border-radius:14px;background:var(--sha-surface);font-size:14px;min-height:52px}.sha-zone-note p{margin:6px 0 0;color:var(--sha-muted)}.sha-zone-note-h{display:flex;align-items:center;flex-wrap:wrap;gap:8px;font-weight:600;font-size:15px}.sha-zone-note-h i{width:10px;height:10px;border-radius:50%}.sha-zone-note-h .sha-badge{margin:0 0 0 4px}.sha-hero-cta{margin-top:18px;width:100%}.sha-lash{margin-top:18px;padding:16px;border-radius:18px;background:linear-gradient(135deg,#fdf1f5,#f7ece2);border:1px solid #f1d6df}.sha-lash-tag{display:inline-block;margin:0 0 12px;padding:5px 12px;border-radius:999px;background:#fff;color:#b23a6b;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}.sha-prod--lash{border:0;background:transparent;padding:0}.sha-lash-note{margin:8px 0 6px;font-size:15px;color:var(--sha-ink)}.sha-lash-how{margin:0 0 14px;font-size:14px;color:var(--sha-muted)}.sha-gate{margin-top:clamp(30px,5vw,44px);padding:clamp(22px,4vw,34px);border-radius:20px;background:linear-gradient(160deg,#F4EADD,#FBF8F3 70%);border:1px solid #E8D9C4;text-align:center}.sha-gate h3{font-size:clamp(28px,4vw,36px);margin:6px 0 8px}.sha-gate .sha-muted{max-width:52ch;margin:0 auto;font-size:15px}.sha-gate-thumbs{position:relative;display:flex;justify-content:center;gap:10px;margin:0 auto 18px}.sha-gate-thumbs img{width:76px;height:76px;object-fit:contain;border-radius:14px;background:#fff;filter:blur(5px) saturate(.9);opacity:.85}.sha-gate-lock{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:grid;place-items:center;width:46px;height:46px;border-radius:50%;background:#1D1A16;color:#fff;box-shadow:0 8px 20px -6px rgba(0,0,0,.45)}.sha-gate-lock svg{width:22px;height:22px}.sha-gate form{display:flex;flex-wrap:wrap;gap:10px;max-width:520px;margin:20px auto 0}.sha-gate input[type=email]{flex:1 1 220px;min-height:52px;padding:0 18px;border-radius:999px;border:1px solid #dccbb3;background:#fff;font:inherit;font-size:16px;color:#1D1A16}.sha-gate input[type=email]:focus{outline:2px solid #8B5A2B;outline-offset:1px}.sha-gate .sha-btn{flex:1 1 180px}.sha-gate small{display:block;margin-top:12px;font-size:12px;color:#6E655B}";
  if (!document.getElementById('sha-map-css')) { var st = document.createElement('style'); st.id = 'sha-map-css'; st.textContent = MAP_CSS; document.head.appendChild(st); }

  function boot() { document.querySelectorAll('[data-soras-ha]:not([data-ha-ready])').forEach(function (el) { el.setAttribute('data-ha-ready', ''); init(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
